import api from '../services/api';
import { $Q, $Qll } from '../utils/query-selector';
import { dataToggle, toggleDataActive } from '../utils/toggle-dataset';

import {
  updateCartItems,
  updatetotalPrice,
  updateUpsell,
  updateCartbutton,
  updatePriceItem,
  updateHeaderCount,
  updateCartpageUpsell,
} from './update-cart';

import { addNodeSpinner } from '../utils/spinner';

const CART_SECTION = 'side-cart,cart-page,header';

window.onload = function () {
  const addToCartButton = $Q(
    'button.btn-1.btn-add-to-cart.product-page-btn.btn-cart-js'
  );
  if (!addToCartButton) return;
  addToCartButton.removeAttribute('disabled');
};

const validateCartPage = (sections) => {
  if (window.location.pathname.includes('cart')) {
    updateCartItems(sections['cart-page']);
  }
};

const updateUpsellCartpage = (section) => {
  if (window.location.pathname.includes('cart')) {
    updateCartpageUpsell(section);
  }
};

/**
 * It checks if product was already added to cart
 * @param {String} body : It is the response from api
 */
const checkAddedProduct = (body, btn) => {
  if (typeof body === 'string' && body.includes('422')) {
    const qtyNotification = $Q('.cart__max-quantity');
    if (!qtyNotification) return;

    if (!btn.classList.contains('btn-checkout')) {
      dataToggle(qtyNotification);

      setTimeout(() => {
        dataToggle(qtyNotification);
      }, 5000);

      return;
    }

    return true;
  }
};

/**
 * Add products in cart
 * @param {event} event -Event submit from add to cart form
 */
const addProducts = async (event) => {
  const addToCartBtn = event.submitter || $Q('.btn-cart-js', event.target);

  addNodeSpinner(addToCartBtn);

  let itemId = 0;

  for (const input of event.target) {
    if (input.name === 'id') {
      itemId = input.value;
    }
  }

  const cartParams = {
    items: [
      {
        id: itemId,
        quantity: 1,
      },
    ],
    sections: CART_SECTION,
  };

  const body = await api.addToCart(cartParams);
  addToCartBtn.innerHTML = addToCartBtn.dataset.text;

  if (!body) return null;

  const added = checkAddedProduct(body, addToCartBtn);

  if (added) {
    window.location.href = '/checkout';
    return;
  }

  const { sections } = body;

  if (!sections) return null;

  if (event.target.dataset.form !== 'upsell') {
    if (addToCartBtn.classList.contains('btn-checkout')) {
      window.location.href = '/checkout';
      return;
    }

    if (addToCartBtn.dataset.template !== 'cart') {
      const status = dataToggle($Q('#side-cart'), true);
      hiddenWidgets(status);
    }
  }

  updateAllCart(sections);
};

/**
 * Join every methods to update side-cart
 * @param {object} sections - Api response
 */
const updateAllCart = (sections) => {
  updateCartItems(sections['side-cart']);
  validateCartPage(sections);
  updateCartbutton(sections['side-cart']);
  updatetotalPrice(sections['side-cart']);
  updatetotalPrice(sections['cart-page']);
  updateUpsell(sections['side-cart']);
  updateHeaderCount(sections['header']);
  updateUpsellCartpage(sections['cart-page']);
};

const submitForm = (form) => {
  form.addEventListener('submit', (e) => {
    e.preventDefault();
    addProducts(e);
  });
};

/**
 * Listen if add to cart form is submited
 * if add to cart form is submited add products in cart
 *
 * @param {string} formQuery - className reference in form add-to-cart
 *
 * To active this feature - ADD className 'add-cart-js' in form product
 * */
export const btnAddToCart = (formQuery) => {
  const addForms = $Qll(formQuery);

  if (addForms != null) {
    addForms.forEach((form) => {
      submitForm(form);
    });
  }
};

/**
 * Replace en element with a spinner
 * @param {String} element
 */
export const addSpinner = (element) => {
  $Q(element).innerHTML = '<div class="loading"></div>';
};

/**
 * Update quantity for each item in cart
 * @param {number} id Product ID
 * @param {number} quantity new quantity
 */
export const updateCart = async (line, quantity, id) => {
  addSpinner(`#price-${id}`);

  const cartParams = {
    line,
    quantity,
    sections: CART_SECTION,
  };

  const { sections = null } = await api.changeCart(cartParams);

  if (!sections) return null;

  if (Number(quantity) === 0) {
    updateCartItems(sections['side-cart']);
    validateCartPage(sections);
    updateCartbutton(sections['side-cart']);
    updatetotalPrice(sections['side-cart']);
    updatetotalPrice(sections['cart-page']);
    updateUpsell(sections['side-cart']);
    updateUpsellCartpage(sections['cart-page']);
  } else {
    updatePriceItem(sections['side-cart'], id);
    updateCartbutton(sections['side-cart']);
    updatetotalPrice(sections['side-cart']);
    updatetotalPrice(sections['cart-page']);
  }

  updateHeaderCount(sections['header']);
};

/**
 * Event onChange in the cart item
 */
export const onChangeItemCart = () => {
  $Qll('.item-cart-js').forEach((input) => {
    input.addEventListener('change', function () {
      updateCart(this.dataset.index, this.value, this.id);
    });
  });
};

/**
 * Delete item in cart
 * listen if delete button is clicked
 * if is clicked, update cart with quantity 0
 */
export const deleteItem = () => {
  const deleteIcon = $Qll('.item-delete');

  if (deleteIcon) {
    deleteIcon.forEach((element) => {
      const {
        dataset: { id, index },
      } = element;
      element.addEventListener('click', () => {
        updateCart(index, 0, `${id}-${index}`);

        //> Suppression_panier
        const { dataset: data } = $Q(
          `.cart-items__container[data-live-item-key*="${id}"] .meta-data`
        );
        console.log('remove_from_cart');
        dataLayer.push({
          event: 'remove_from_cart',
          ecommerce: {
            currency: window.Shopify.currency.active,
            value: parseFloat(data.price),
            items: [
              {
                item_id: data.item_id,
                item_serialcode: data.item_serialcode,
                item_name: data.item_name,
                index: 0,
                currency: window.Shopify.currency.active,
                item_brand: data.item_brand,
                item_category: data.item_category,
                item_category2: data.item_exteriorcolor,
                item_category3: data.item_interiorcolor,
                item_category4: data.item_exteriormaterial,
                item_category5: data.item_interiormaterial,
                item_category6: data.item_hardware,
                item_category7: data.item_year,
                item_variant: data.item_variant,
                item_size: [data.depth, data.width, data.height],
                quantity: Number(data.quantity),
                price: parseFloat(data.price),
                discount_type:
                  data.discount_type !== ''
                    ? data.discount_type.split(',')
                    : 'N/A',
              },
            ],
          },
        });
      });
    });
  }
};

/**
 * Open and close side cart with various buttons
 */
export const openCloseCart = () => {
  const cartContainer = $Q('.cart');

  if (cartContainer.dataset.template === 'cart') return;

  cartContainer.setAttribute('data-active', 'false');

  toggleDataActive('.cart-close', '#side-cart', {
    overlay: true,
    type: 'side-cart',
    blockScroll: true,
  });

  toggleDataActive('.button-cart', '#side-cart', {
    overlay: true,
    type: 'side-cart',
    blockScroll: true,
  });
};

export const hiddenWidgets = (status) => {
  const widget = $Q('#gorgias-chat-container');

  if (!widget) return;

  if (status && !widget.classList.contains('hidden')) {
    widget.classList.add('hidden');
  } else if (!status && widget.classList.contains('hidden')) {
    widget.classList.remove('hidden');
  }
};
